<template>
<div class="chapter">
<div class="inner_page">
<p class="hero" id="start"><a id="epigraph"></a><a id="pagexi">A hero ventures forth from the world of common day into a region of supernatural wonder: fabulous forces are there encountered and a decisive victory is won: the hero comes back from this mysterious adventure with the power to bestow boons on his fellow man.</a></p><a id="pagexi">
<blockquote>
<p class="ind"><span class="small">—</span>J<span class="small">OSEPH</span> C<span class="small">AMPBELL,</span></p>
<p class="ind"><i>The Hero with a Thousand Faces</i></p>
</blockquote>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 5-start.vue?57aeb964